import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const UpdateRoleDialog = ({
  open,
  user,
  roles = [],
  loading = false,
  rolesLoading = false,
  onClose,
  onSubmit,
}) => {
  const [selectedRoles, setSelectedRoles] = useState([]);

  const roleOptions = useMemo(() => {
    const fromApi = (roles || []).map((role) =>
      typeof role === "string" ? role : role?.name || role?.role || String(role)
    );
    const current = Array.isArray(user?.roles) ? user.roles : [];
    return Array.from(new Set([...fromApi, ...current].filter(Boolean)));
  }, [roles, user]);

  useEffect(() => {
    if (open) {
      setSelectedRoles(Array.isArray(user?.roles) ? [...user.roles] : []);
    }
  }, [open, user]);

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Role</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Assign roles for{" "}
          <strong>{user?.username || user?.userId || "selected user"}</strong>
        </Typography>
        <Autocomplete
          multiple
          options={roleOptions}
          value={selectedRoles}
          loading={rolesLoading}
          onChange={(_, value) => setSelectedRoles(value)}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={option}
                size="small"
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Roles"
              placeholder="Select roles"
              helperText={
                roleOptions.length
                  ? "Select one or more roles"
                  : "Role catalog API is not available yet. Current user roles are shown."
              }
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={loading || selectedRoles.length === 0}
          onClick={() => onSubmit(selectedRoles)}
        >
          {loading ? "Saving..." : "Save Roles"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRoleDialog;
